<template lang="pug">
a.inline-flex.items-center(:class="cn(LinkTypes({ type }), $attrs.class ?? 'items-center')")
  component(:is="icon" v-if="icon")
  slot
</template>

<script setup lang="ts">
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'
interface Props {
  type?: 'success' | 'warning' | 'danger' | 'info' | 'primary' | 'default'
  icon?: Component
}
const LinkTypes = cva('hover:underline hover:underline-offset-4', {
  variants: {
    type: {
      default: 'text-primary-500',
      primary: 'text-primary-500',
      success: 'text-[var(--nephritis)]',
      warning: 'text-yellow-500',
      danger: 'text-red-500',
      info: 'text-gray-500',
    }
  },
  defaultVariants: {
    type: 'primary',
  },
})
withDefaults(defineProps<Props>(), {
  type: 'primary',
  icon: undefined,
})
</script>
